/*
 * File: d:\projects\AutoFiFront\public\BrandSvg\CUPRA.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:04:05 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function CUPRA(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M216.1,330.07c106.27,36.96,211.96,75.63,318.48,111.85,3.77,1.46,7.5,1.46,11.27,0,106.34-36.39,211.96-74.74,318.05-111.85-37.64,59.99-75.63,119.77-114.08,179.23-17.77-7.64-36.07-14-53.99-21.32,10.38-18.27,21.54-36.11,32.06-54.31-34.26,17.24-69.13,33.27-103.14,51,23.78,9.06,47.59,17.95,71.19,27.51,13.15,5.37,27.26,15.71,28.15,31.13,2.1,17.13-9.6,31.13-17.88,44.85-51.25,80.18-102.21,160.57-153.71,240.61,.28-21.11-2.13-42.44,.36-63.4,20.26-64.29,40.27-128.66,58.71-193.48,3.63-9.63-7.14-14.78-14.07-18.16-19.55-8.64-37.85-20.08-57.86-27.47-20.29,8.78-39.77,19.41-59.67,29.04-6.15,2.84-14.82,8.46-11.3,16.49,18.3,64.86,38.53,129.19,58.64,193.52,2.24,21,.11,42.33,.21,63.48-50.68-79.33-101.25-158.76-151.86-238.12-8.81-14.61-21.61-29.53-19.41-47.77,1.17-15.32,15.21-25.48,28.36-30.81,23.39-9.52,47.13-18.23,70.69-27.44-33.94-17.66-68.66-33.83-102.89-50.93,10.48,18.2,21.64,36,31.99,54.31-18.02,7.18-36.25,13.83-54.2,21.18-38.31-59.53-76.23-119.34-114.08-179.12h0Z"/>
        </svg>
    );
}

export default CUPRA;
